export default __webpack_public_path__ + "static/media/017-pirate-1.54847c98.png";